import React from "react";
import styled from "styled-components";
import { IoIosArrowForward } from "react-icons/io";
import Bubble from "./Bubble";
import Theme from "../vars/ThemeOptions";

const Wrap = styled.div`
  position: relative;
  top: 2px;
  ${({scale}) => scale ? `transform: scale(${scale})` : ''};
  .arrow-wrap {
    position: relative;
    top: -9px;
    right: -4px;
    z-index: 10;
    color: white;
    font-size: 1.4rem;
  }
`;

const CustomListBullet = ({ darkBlue, scale }) => {
  return (
    <Wrap scale={scale}>
      <Bubble
        size={`20px`}
        top={`0`}
        left={`5px`}
        bg={Theme.hex("primary")}
        zIndex={2}
      />
      <Bubble
        size={`20px`}
        top={`0`}
        left={`0`}
        bg={darkBlue ? Theme.hex("darkSecondary") : Theme.hex("secondary")}
        zIndex={1}
      />
      <div className="arrow-wrap">
        <IoIosArrowForward />
      </div>
    </Wrap>
  );
};

export default CustomListBullet;
